import { CompanyPolicyId, CompanyPolicyResponse, CompactCompanyPolicyResponse } from '@business/entities/library';
import { CommonService } from '@business/services';
import { Endpoint } from '../endpoint';
import { CompanyId } from '@business/entities/companies';
import { LibraryItemType } from '@business/entities/library';

export function fetchCompanyPolicies(companyId: CompanyId, isCompact?: boolean, type?: LibraryItemType) {
  return Endpoint.get<CompactCompanyPolicyResponse[]>(`@makh/company-policy`, { params: { companyId, isCompact, type } });
}

export function fetchCompanyPolicy(id: CompanyPolicyId) {
  return Endpoint.get<CompanyPolicyResponse>(`@makh/company-policy/policy/${id}`);
}

export function createCompanyPolicy(data: Partial<CompanyPolicyResponse>) {
  const form = { ...data };
  const formData = CommonService.toFormData(form);
  return Endpoint.post<CompanyPolicyResponse>(`@makh/company-policy`, { formData, hasFiles: true });
}

export function updateCompanyPolicy(companyPolicyId: CompanyPolicyId, data: Partial<CompanyPolicyResponse>) {
  const form = { ...data };
  const formData = CommonService.toFormData(form);
  formData.append('_method', 'patch');
  return Endpoint.post<CompanyPolicyResponse>(`@makh/company-policy/${companyPolicyId}`, { formData, hasFiles: true });
}

export function deleteCompanyPolicy(companyPolicyId: CompanyPolicyId) {
  return Endpoint.delete<void>(`@makh/company-policy/${companyPolicyId}`);
}
